import {t} from "@lingui/core/macro";
import {StyleSheet} from "aphrodite";
import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";

import PageRoot from "#app-shell-package/page-root.tsx";

import Footer from "./components/footer.tsx";
import Header from "./components/header.tsx";
import ImageLadder from "./components/image-ladder.tsx";
import LoveToLearn from "./components/love-to-learn.tsx";
import SponsorsArea from "./components/sponsors-area.tsx";
import {withStrings} from "./locales/khankids/load-strings.tsx";

type Props = Record<any, any>;

class KhanKidsLandingPage extends React.Component<Props> {
    render(): React.ReactNode {
        const ladderImages = [
            {
                title: t`It's personalized`,
                description: t`Our personalized learning path dynamically adapts, ensuring each child is presented with activities, books, educational videos, and creative lessons that allow them to learn at their own pace, creating an individualized experience for every learner.`,
                imgUrl: "/images/kids/screen-1-personalized@2x.png",
                imgAltText: t`Illustration of a tablet showing the Khan Academy Kids home screen`,
            },
            {
                title: t`Independent Learning`,
                description: t`Kids can learn independently in the the Khan Academy Kids Library—a curated collection of activities, books, videos, and coloring pages. Our book reader allows students to follow along with recorded audio narration or read on their own across our fiction, non-fiction and fiction leveled books.`,
                imgUrl: "/images/kids/screen-2-independent@2x.png",
                imgAltText: t`Illustration of a tablet showing the Khan Academy Kids library screen`,
            },
            {
                title: t`Holistic Approach`,
                description: t`A holistic approach engages students in core subjects like early literacy, language, and math while encouraging creativity and building social-emotional skills.`,
                imgUrl: "/images/kids/screen-3-hollistic@2x.png",
                imgAltText: t`Illustration of a tablet showing Kodi and friends looking out with the text, 'Look! We see it! Come on, let's go!'. Two callouts sit on top of the tablet with the headings, 'Sharing' and 'Helping'.`,
            },
            {
                title: t`Robust Curriculum`,
                description: t`Thousands of activities for kids ages two to eight. Aligned with the Head Start Early Learning Outcomes Framework and Common Core Standards delve deep into topics ranging from math to motor development.`,
                imgUrl: "/images/kids/screen-4-curriculum@2x.png",
                imgAltText: t`Illustration of two tablets, each showing examples of exercises from inside the Khan Academy Kids app.`,
            },
        ];

        return (
            <PageRoot>
                <View>
                    <Header />
                    <LoveToLearn sectionHeader={t`Kids will love to learn.`} />
                    <View style={styles.imageLadder}>
                        <ImageLadder
                            title={t`Unique for every learner.`}
                            images={ladderImages}
                        />
                    </View>
                    <Footer />
                    <SponsorsArea />
                </View>
            </PageRoot>
        );
    }
}

export default withStrings(KhanKidsLandingPage);

const styles = StyleSheet.create({
    imageLadder: {
        backgroundColor: "white",
        paddingTop: 60,
    },
});
